export default __webpack_public_path__ + "static/media/whitePlus.48fd88b2.svg";